import { createFileRoute } from '@tanstack/react-router';
import 'allotment/dist/style.css';

import { useAssociation } from '@/routes/arc/-hooks/use-association.ts';
import '@/routes/arc/-styles/index.scss';
import RejectCallReasonForm from '@/routes/arc/-widgets/reject-call-form/RejectCallReasonForm.tsx';
import AssociatedNotificationCall from '@/routes/arc/_sip/call/calling/-associated-notification-call/AssociatedNotificationCall.tsx';
import Profile from '@/routes/arc/_sip/profile/-Profile.tsx';
import { cn } from '@/utils/cn';

import AssociatedTempNotes from './-associated-temp-notes/AssociatedTempNotes.tsx';
import OperationPanel from './-operation-panel/OperationPanel.tsx';

export const Route = createFileRoute('/arc/_sip/call/calling')({
  component: CallInPage,
});

function CallInPage() {
  const association = useAssociation();

  return (
    <>
      <div className={cn('flex min-h-0 flex-1')}>
        <div className={'fit-col'}>
          <div className={cn('fit-col', 'p-2.5')}>
            <AssociatedTempNotes />
            <AssociatedNotificationCall />
            <Profile hasBack={false} showEdit={true} showSwitch={true} />
          </div>
        </div>
        <div className={'fit-col max-w-90 min-w-90'}>
          <div className={'flex h-full flex-col gap-2.5 py-2.5 pr-2'}>
            <OperationPanel association={association} />
          </div>
        </div>
      </div>
      <RejectCallReasonForm />
    </>
  );
}
